<template>
    <b-row class="error-500-redirect-component">
        <b-col lg="12">
            <a @click="reload()" class="button--primary">Try again</a>
        </b-col>
    </b-row>
</template>

<script>
    export default {
        methods: {
            reload () {
                window.location.reload()
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../assets/scss/_colors.scss';
    @import '../../../assets/scss/_buttons.scss';

    .error-500-redirect-component{
        margin-top: 50px;

        p{
            font-weight: normal;
            color: $white;
            margin-bottom: 11px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/errors/500/Error500Redirect.vue